define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/FAssetAttrTypeVal"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, FAssetAttrTypeVal_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FAssetAttrType = void 0;
    class FAssetAttrType extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "AssetGroup", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetGroupError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Desc_", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Desc_Error", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsFreeText", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsFreeTextError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetAttrTypeVal", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFAssetAttrTypeVal", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetAttrTypeValError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FAssetAttrType.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.FAssetAttrTypeVal = [];
        }
        onRead(entity, parent) {
            this.FAssetAttrTypeVal = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.AssetGroup = b.AssetGroup;
            a.AssetDesc = b.AssetDesc;
            a.Desc_ = b.Desc_;
            a.IsFreeText = (0, EntityUtil_1.toInt)(entity.IsFreeText);
            a.FAssetAttrTypeVal = this.mergeArray(a.FAssetAttrTypeVal, b.FAssetAttrTypeVal, FAssetAttrTypeVal_1.FAssetAttrTypeVal);
            a.SelectedFAssetAttrTypeVal = a.SelectedFAssetAttrTypeVal && a.FAssetAttrTypeVal.find(x => x.Id == a.SelectedFAssetAttrTypeVal.Id) ? a.SelectedFAssetAttrTypeVal : null;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FAssetAttrType.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqString(validationState, "AssetGroup", "Group");
                this.validateReqString(validationState, "Desc_", "Description");
                this.validateReqNumber(validationState, "IsFreeText", "Allow Free Text?");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.FAssetAttrTypeVal) {
                for (let x of this.FAssetAttrTypeVal) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                AssetGroup: this.AssetGroup,
                AssetDesc: this.AssetDesc,
                Desc_: this.Desc_,
                IsFreeText: this.IsFreeText,
                FAssetAttrTypeVal: this.FAssetAttrTypeVal.map(x => x.toJson()),
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.FAssetAttrType = FAssetAttrType;
    Object.defineProperty(FAssetAttrType, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FAssetAttrType"
    });
    Object.defineProperty(FAssetAttrType, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Asset Attribute Type"
    });
    Object.defineProperty(FAssetAttrType, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "AssetGroup", "AssetDesc", "Desc_", "IsFreeText"]
    });
    Object.defineProperty(FAssetAttrType, "AssetGroupLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAssetAttrType, "AssetGroupReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetAttrType, "AssetDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAssetAttrType, "AssetDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAssetAttrType, "Desc_Length", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAssetAttrType, "Desc_Req", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAssetAttrType, "IsFreeTextReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "AssetGroup", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "AssetGroupError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "AssetDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "AssetDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "Desc_", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "Desc_Error", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "IsFreeText", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "IsFreeTextError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "FAssetAttrTypeVal", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "SelectedFAssetAttrTypeVal", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAssetAttrType.prototype, "FAssetAttrTypeValError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FAssetAttrType.prototype, "merge", null);
});
